export const i18nReportsPage = {
  summary: {
    title: 'Saúde do Ativo',
    severity: {
      status: {
        title: 'Desvios de Condição',
        caseTitle: 'Casos',
        4: 'Muito Alto',
        3: 'Alto',
        2: 'Médio',
        1: 'Baixo',
        TOTAL: 'Total',
        modec: {
          5: 'Condição Crítica',
          4: 'Problema Potencial',
          3: 'Condição de Alarme',
          2: 'Não Monitorado',
          1: 'Não Operado',
          0: 'Condição Normal',
          TOTAL: 'Total',
        },
      },
    },
    actions: {
      pdf: 'Relatório',
    },
  },
  assetsList: {
    columns: { health: 'Saúde', asset: 'Ativo' },
  },
  home: {
    common: { reports: 'Relatórios', rert: 'Pontuação de Saúde RERT', performance: 'Performance' },
    description: {
      performance:
        'O Relatório de Performance monitora os KPIs de produção por sistema e embarcações: Produção de Petróleo, Água Produzida, Desidratação de Gás e IUGA.',
      rert: 'O RERT é um relatório mensal que fornece a pontuação de saúde para todas as plantas com navegação detalhada por sistema e subsistemas, mostrando desvios de condição associados.',
    },
  },
  labels: {
    CSV: 'CSV',
    goToPi: 'Ir para PI',
    noData: 'Desculpe, o relatório não está disponível.',
    pdf: 'PDF',
  },
  pdfModal: {
    title: 'Exportar Relatório mensal',
    labels: {
      vessel: 'Selecione um Vessel',
      month: 'Mês',
      documentName: 'Nome do documento',
    },
    buttons: {
      cancel: 'Cancelar',
      generate: 'Download PDF',
    },
    error: 'PDF não está disponível para este ativo',
  },
  commentModal: {
    labels: {
      error: 'Erro',
      fieldPlaceholder: 'Digite os comentários',
      modalTitle: 'Comentário para o dia ',
      save: 'Salvar',
      success: 'Sucesso',
    },
    messages: {
      success: 'Alterações aplicadas com sucesso!',
      error: 'Por favor, tente novamente ou entre em contato com o suporte.',
    },
  },
  modalSuccess: {
    done: 'Concluído',
    successfulConditionDeviation: 'O desvio de condição foi criado com sucesso',
    successEditCD: 'O desvio de condição foi atualizado com sucesso',
  },
};
